import { FC, useEffect, useState } from 'react';

import { useManagerQuery } from 'Dictionary/query/dictionaryQuery';
import { FormikAutocompleteField } from 'components/FormikField/FormikAutocompleteField/FormikAutocompleteField';
import { mapToAutocompleteFieldItems } from 'MyProfile/model/MyProfile';

export interface ManagerSelectFieldProps {
  name: string;
  initialValue?: string;
  disabled?: boolean;
}

const searchTimeout = 1000;
const minLenOfSearchValue = 3;

export const ManagerSelectField: FC<ManagerSelectFieldProps> = ({
  name,
  initialValue,
  disabled = false,
}) => {
  const [value, setValue] = useState('');
  const { data = [], isLoading, isFetching, refetch } = useManagerQuery(value);

  useEffect(() => {
    if (initialValue !== value && value.length >= minLenOfSearchValue) {
      const timer = setTimeout(refetch, searchTimeout);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [value]);

  return (
    <FormikAutocompleteField
      name={name}
      label="Hierarchical Manager"
      helperText="Type Firstname Lastname (at least 3 letters)"
      disabled={disabled}
      options={mapToAutocompleteFieldItems(data)}
      loading={isLoading || isFetching}
      onInputChange={(event, eventValue) => setValue(eventValue)}
      required
      filterOptions={(options) => options}
    />
  );
};
